<atx-card class="pcard h-100 border-0 position-relative">
  <div class="product-card-header">
    <atx-product-card-header
      [product]="product"
      [showMarkup]="showMarkup"
      [prices]="prices"
      [idFields]="headerInputArgs.idFields"
      [showWholeSalePrice]="headerInputArgs.showWholeSalePrice"
      [showWspdPrice]="headerInputArgs.showWspdPrice"
      [titleFields]="headerInputArgs.titleFields"
    ></atx-product-card-header>
  </div>
  <div
    class="product-card-subheader"
    [class.visible-on-hover]="showIconsOnHover$ | async"
  >
    <div class="absolute-wrapper">
      <atx-product-card-icons
        [product]="product"
        [showPopularityIcon]="showPopularityIcon"
        [showGenderIcon]="iconsInputArgs.showGenderIcon"
        [language]="iconsInputArgs.language"
        [dateFormat]="iconsInputArgs.dateFormat"
        data-e2e="pcard-icons"
        class="flex-1"
      >
      </atx-product-card-icons>
      @if (showActions) {
      <atx-product-card-actions
        [product]="product"
        [deletable]="deletable"
        [currentVariantMedia]="currentVariantMedia"
        [previewAttributes]="actionsInputArgs.previewAttributes"
        [replenishments]="actionsInputArgs.replenishments"
        [addedToActiveList]="actionsInputArgs.addedToActiveList"
        (addProductToActiveList)="onAddProductToActiveList()"
        (removeProductFromActiveList)="onRemoveProductFromActiveList()"
        (deleteFromProductList)="onDeleteFromProductList()"
        data-e2e="pcard-actions"
        class="flex-shrink-0"
      >
      </atx-product-card-actions>
      }
    </div>
  </div>

  <div class="card-container">
    <div class="d-flex flex-grow-1 flex-column">
      <div class="flex-grow-1 image-container">
        <div class="pt-2 h-100">
          <atx-image
            class="img-fluid h-100"
            [imageUrl]="product.mainImageUrl ?? ''"
            [maxWidth]="imageMaxSizes.XXSMALL"
            [objectFit]="objectFit.CONTAIN"
            [enableProgressiveLoad]="enableProgressiveImageLoad"
            data-e2e="current-media"
          >
          </atx-image>
        </div>
      </div>
      <div class="product-card-footer position-relative">
        @if (productReference) {
        <div class="position-relative inset-cover w-100 h-100">
          @if (isMobile$ | async) {
          <div class="size-container text-center rounded-circle h2-font-size">
            {{ productReference.totalRequestedQuantity }}
          </div>
          } @else {
          <div
            [atxPopover]="popoverContent"
            triggers="hover"
            [popoverPlacement]="Placement.TOP"
            class="size-container text-center rounded-circle cursor-pointer h1-font-size"
          >
            {{ productReference.totalRequestedQuantity }}
          </div>
          }
        </div>
        <div
          class="d-flex w-100 align-items-center px-3 position-absolute inset-cover body-bg product-card-footer-price-holder"
          [class.justify-content-between]="showCommercialListDate"
          [class.justify-content-center]="showCommercialListDate === false"
        >
          <div
            class="font-weight-bold h5-font-size"
            [class.text-warning]="
              this.isSomePricesMissed && !this.allPricesMissed
            "
            [atxTooltip]="
              this.allPricesMissed ? missedAllPricesTxt : missedSomePricesTxt
            "
            [tooltipEnabled]="isPriceTooltipEnabled"
          >
            @if (this.allPricesMissed) {
            <ng-container
              i18n="
                ProductList|Commercial list missed all prices p-card
                text@@missedAllPricesPcardtext"
            >
              n/a
            </ng-container>
            } @else {
            {{
              productReference.totalPrice
                | formatPrice: productReference.currency
            }}
            }
          </div>
          @if ( showCommercialListDate && productReference.earliestDeliveryDate
          ) {
          <div class="text-muted">
            {{ productReference.earliestDeliveryDate | utcDate: dateFormat }}
          </div>
          }
        </div>
        }
      </div>
    </div>
    @if (discountVisible) {
    <div class="position-absolute discount">
      <atx-discount-label
        *atxCanShowByWsp
        class="d-block badge-success"
        [discount]="discount"
      ></atx-discount-label>
    </div>
    }
  </div>

  @if (isDraggable) {
  <div
    class="drag-container hover-show d-flex justify-content-center align-items-center"
    [class.invisible]="isMobile$ | async"
  >
    <ng-container [ngTemplateOutlet]="dragAndDropHandleTemplate"></ng-container>
  </div>
  }

  <ng-template #popoverContent>
    <epc-preview-product-sizes-v2
      [articleId]="product.parentId"
      [brandId]="product.brandId"
      [previewItems]="deliveryInfoItems"
    ></epc-preview-product-sizes-v2>
  </ng-template>
</atx-card>
